import i18next from 'i18next'
import * as React from 'react'
import { InviewProps } from '../blocksState'
import { LinkGridBlockLayout } from '../linkGridBlockLayout'
import { getImageUrls } from '../../../../utils/sharepointImageUrls'
import { linkGridSrc, linkGridSrcSet } from '../../../../utils/imageSizes'
import { EventPage } from '../../cmsPageState'


export type AllEventsBlockProps = {
  index: number
  inview?: InviewProps
  title?: React.ReactNode
  children: EventPage[]
  eventCount: number
  teaser: boolean
}

export function AllEventsBlockLayout(props: AllEventsBlockProps) {
  return (
    <LinkGridBlockLayout
      index={props.index}
      title={props.title}
      inview={props.inview}
      withImages={true}
      imageOptions={{
        src: linkGridSrc,
        srcset: linkGridSrcSet,
        sizes: 'auto',
        lazyload: true,
        width: '320',
        height: '160'
      }}
      noItemsMessage={i18next.t('event:lackOfEventsMessage')}
      isEventBlock={true}
      eventCount={props.eventCount}
      teaser={props.teaser}
      items={props.children.map(x => ({
        title: x.title,
        intro: x.intro ?? '',
        link: {
          url: x.path,
          title: x.title
        },
        booster: x.eventBoostLabel,
        date: x.eventDate,
        location: x.eventLocation,
        image: !!x.image
          ? {
              alt: x.title,
              urls: getImageUrls(x.image),
              keepOriginalSize: false
            }
          : undefined
      }))}
    />
  )
}
